import { GoalsService } from "@/clients/services/GoalsService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useQuery } from "@tanstack/react-query";

export const useGetGoals = () => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: [QueryKeys.GOALS],
    queryFn: async () => {
      const user = guardGetUserFromLocalStorage();
      const { data } = await GoalsService.getGoalsApiV1GoalsGet(user.id);

      return data;
    },
  });

  return {
    goals: data,
    isLoading,
    isError,
    error,
  };
};
